import React from 'react';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { Button as RenderButton } from '@whalecloud/fdx';
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';

const Button = props => {
  const { element, nameSpace } = props;
  const { type = 'default', className = '' } = element.data || {};

  const { formItemSettings, formSettings } = element.data || {};
  const { text, icon, ...restProps } = formItemSettings;
  const eventProps = makeEventProps(element.data.events, nameSpace);

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div
          style={{ ...elementStyle, display: 'inline-block' }}
          className={getAllClasses(
            'webiny-pb-page-element-button',
            'webiny-pb-page-element-button--' + type
          )}
          {...formSettings}
        >
          <RenderButton {...restProps} {...eventProps} className={className}>{icon && <span>{icon}</span>}{text}</RenderButton>
        </div>
      )}
    </ElementRoot>
  )
};

export default Button;